import React, { ReactElement } from 'react'

import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select, { SelectProps } from '@mui/material/Select'

const LicenseTypeDropdown = ({
  name = 'type',
  value,
  label = 'Type',
  variant = 'standard',
  onChange,
  onBlur,
  error,
  errorText,
  disabled,
  bgDefault,
  bgDefaultColor,
}: SelectProps<string> & {
  errorText?: string
  bgDefault?: boolean
  bgDefaultColor?: string
}): ReactElement => (
  <FormControl fullWidth error={error} disabled={disabled}>
    <InputLabel sx={variant === 'standard' ? { ml: -1.75, mt: 1 } : undefined}>
      {label}
    </InputLabel>
    <Select
      sx={{
        bgcolor: !bgDefault
          ? bgDefaultColor || 'background.paperDark'
          : undefined,
      }}
      variant={variant}
      value={value}
      label={label}
      name={name}
      onBlur={onBlur}
      onChange={onChange}
    >
      <MenuItem value="unselected">Unselected</MenuItem>
      {/* If these values ever change, move them to a settings endpoint */}
      <MenuItem value="AEMT">AEMT</MenuItem>
      <MenuItem value="Advanced Care Paramedic (Canada Only)">
        Advanced Care Paramedic (Canada Only)
      </MenuItem>
      <MenuItem value="CFR">Certified First Responder</MenuItem>
      <MenuItem value="EMR">Emergency Medical Responder</MenuItem>
      <MenuItem value="EMT">EMT</MenuItem>
      <MenuItem value="EMT-1">EMT-1</MenuItem>
      <MenuItem value="EMT-2">EMT-2</MenuItem>
      <MenuItem value="EMT-B">EMT-B</MenuItem>
      <MenuItem value="EMT-CC">EMT-CC</MenuItem>
      <MenuItem value="EMT-D">EMT-D</MenuItem>
      <MenuItem value="Paramedic">Paramedic</MenuItem>
      <MenuItem value="Physician">Physician</MenuItem>
      <MenuItem value="Physician Assistant">Physician Assistant</MenuItem>
      <MenuItem value="Primary Care Paramedic (Canada Only)">
        Primary Care Paramedic (Canada Only)
      </MenuItem>
      <MenuItem value="Registered Nurse">Registered Nurse</MenuItem>
      <MenuItem value="Other">Other</MenuItem>
    </Select>
    <FormHelperText>{errorText}</FormHelperText>
  </FormControl>
)

export default LicenseTypeDropdown
